import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'aa-hero-section',
  standalone: true,
  imports: [],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroSectionComponent {}
